import { makeStyles, tokens } from '@fluentui/react-components';
import { AppBarWide } from '@office-start/appbar-control';
var useStyles = makeStyles({
    container: {
        minWidth: AppBarWide,
        backgroundColor: tokens.colorNeutralBackground4,
    },
});
export var AppBarComponentFallback = {
    useContainerStyles: useStyles,
    node: null,
};
//# sourceMappingURL=AppBarComponentFallbackOptions.js.map